import React, {useEffect} from "react";
import { Typography, MenuItem, TextField, Grid, Button, IconButton, Box } from "@mui/material";
import { Add, Close } from "@mui/icons-material";
import EspecesForm from "./especes-form";
import ChequesForm from "./chèques-form";
import VirmentForm from "./virment-form";
import { theme } from "../App";

export default function PaymodeForm(props) {
    useEffect(()=>{}, [props.pay_mode])

    return(
        <Grid container spacing={2} sx={{maxWidth:'100%'}}>
            {props.pay_mode.map((mode, index) => 
            <Grid key={mode} item sm={6} sx={{backgroundColor:'purple'}}> 
                {props.pay_mode.length>1 && 
                <IconButton 
                aria-label="supprimer"
                sx={{padding:0}} 
                onClick={()=>{
                    props.setReptotal(old => {
                        if (mode==="especes") {
                            if (props.isdepense) {
                                props.setEspeces(0)
                                return old-props.especes
                            } else {
                                const especes = props.repEspeces.reduce((accumulator, currentValue) => {
                                    return accumulator + (Number(currentValue.montant) * Number(currentValue.count));
                                }, 0)
                                props.setRepEspeces(([{montant:"", count: 0}]))
                                return old-especes
                            }
                        } else if (mode==="cheques") {
                            const cheques = props.repCheques.reduce((accumulator, currentValue) => {
                                return accumulator + Number(currentValue.montant);
                            }, 0)
                            props.setRepCheques([{banque:'', montant:0, num_cheque:''}])
                            return old-cheques
                        } else if (mode==="virement") {
                            props.setRepVir({date:"", montant:0, ref: ''})
                            return old-props.repVir.montant
                        } else if(!props.isdepense){
                            props.setRepCB({date:"", montant:0, ref: ''})
                            return old-props.repCB.montant
                        }
                    })
                    props.setMode(old => old.slice(0, index).concat(old.slice(index+1)))
                }}>
                    <Close/>
                </IconButton>}
                <TextField
                id="outlined-select-currency"
                select
                sx={{minWidth:'300px', alignSelf:'flex-start', marginTop:'20px'}}
                required
                label="Mode de paiement"
                value={props.pay_mode[index]}
                onChange={(e)=> {
                    props.setReptotal(old => {
                        if (mode==="especes") {
                            if (props.isdepense) {
                                props.setEspeces(0)
                                return 0
                            } else {
                                const especes = props.repEspeces.reduce((accumulator, currentValue) => {
                                    return accumulator + (Number(currentValue.montant) * Number(currentValue.count));
                                }, 0)
                                props.setRepEspeces(([{montant:"", count: 0}]))
                                return old-especes
                            }
                        } else if (mode==="cheques") {
                            const cheques = props.repCheques.reduce((accumulator, currentValue) => {
                                return accumulator + Number(currentValue.montant);
                            }, 0)
                            props.setRepCheques([{banque:'', montant:0, num_cheque:''}])
                            return old-cheques
                        } else if (mode==="virement") {
                            props.setRepVir({date:"", montant:0, ref: ''})
                            return old-props.repVir.montant
                        } else if(!props.isdepense){
                            props.setRepCB({date:"", montant:0, ref: ''})
                            return old-props.repCB.montant
                        } else return old
                    })
                    props.setMode(old => {const newArray = [...old]; newArray[index] = e.target.value; return newArray})
                }}>
                    <MenuItem key={"especes"} value={"especes"} disabled={props.pay_mode.includes("especes")}>
                        <Typography>Espèces</Typography> 
                    </MenuItem>
                    <MenuItem key={"cheques"} value={"cheques"} disabled={props.pay_mode.includes("cheques")}>
                        <Typography>Chèque</Typography> 
                    </MenuItem>
                    <MenuItem key={"virement"} value={"virement"} disabled={props.pay_mode.includes("virement")}>
                        <Typography>Virement</Typography> 
                    </MenuItem>
                    {!props.isdepense && <MenuItem key={"cb"} value={"cb"} disabled={props.pay_mode.includes("cb")}>
                        <Typography>CB</Typography> 
                    </MenuItem>}
                </TextField>

                <Typography sx={{marginY: '10px'}}>Détails*:</Typography>
                {props.pay_mode[index]==='especes' && (props.isdepense ?
                <TextField
                fullWidth
                name="montant"
                label="Montant (en €)"
                inputProps={{step:"0.01", min:'0'}}
                type="number"
                value={props.especes}
                onFocus={()=>{if(props.especes===0) props.setEspeces('')}}
                onChange={(e)=>{if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0){
                    props.setReptotal(old => old-props.especes+Number(e.target.value))
                    props.setEspeces(Number(e.target.value))
                }else if(e.target.value===''){
                    props.setReptotal(old => old-props.especes)
                    props.setEspeces('')
                }}}/>
                :<EspecesForm 
                reptotal={props.reptotal} 
                setReptotal={props.setReptotal} 
                total={props.total} 
                repartition={props.repEspeces} 
                setRepartition={props.setRepEspeces}/>)}
                {props.pay_mode[index]==='cheques' && 
                <ChequesForm 
                reptotal={props.reptotal} 
                setReptotal={props.setReptotal} 
                total={props.total} 
                repartition={props.repCheques} 
                setRepartition={props.setRepCheques}
                isdepense={props.isdepense}/>}
                {(props.pay_mode[index]==='virement'||props.pay_mode[index]==='cb') && 
                <VirmentForm 
                reptotal={props.reptotal} 
                setReptotal={props.setReptotal} 
                repartition={props.pay_mode[index]==='virement' ? props.repVir : props.repCB} 
                setRepartition={props.pay_mode[index]==='virement' ? props.setRepVir : props.setRepCB} 
                pay_mode={mode}
                don_date={props.isdepense? Date.now() : props.don_date}
                isdepense={props.isdepense}/>} 
            </Grid>)}  

            {props.pay_mode.length <(props.isdepense? 3 : 4) && props.reptotal<props.total && props.pay_mode[props.pay_mode.length-1]!=='' && 
            <Grid item sm={2}>
                <Button aria-label="ajouter un mode paiement" 
                variant="contained" 
                color="primary" 
                fullWidth
                sx={{paddingX:0, width:'100%'}}
                onClick={()=> props.setMode(old => old.concat(['']))}>
                    <Add sx={{margin:0}}/>
                    <Typography>mode de paiment</Typography> 
                </Button>
            </Grid>}
            
            <Grid item sm={12}>
                <Typography variant="h5" color='primary' sx={{fontWeight:'bold', marginBlock:2, marginLeft:5}}>
                    TOTAL RÉPARTITION: <span style={{color:props.total!==props.reptotal? theme.palette.carmine.main : theme.palette.valide.main}}>{props.reptotal.toFixed(2)}€</span> / {props.total.toFixed(2)}€
                </Typography> 
            </Grid>      
        </Grid>
    )
}